<div class="xi-tag-button__container" [matTooltip]="tooltip">
  <xi-default-button
    [text]="text"
    [iconLeft]="icon"
    [isIconLeftButton]="true"
    [hasAnimation]="false"
    [color]="color"
    [tone]="tone"
    buttonSize="small"
    (onIconClick)="onIconClicked($event)"
  ></xi-default-button>
</div>
